var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SimplePanel from '@/shared/components/SimplePanel';
import messages from '@/modules/tasks/taskboard/taskboardMessages';
import { useIntl } from 'react-intl';
import { CanCreate } from '@/shared/components/security';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import taskMessages from '@/modules/tasks/taskMessages';
import { FilterUserSearch } from '@/shared/components/input/filterInputs/FilterUserSearch';
import { FilterStatusSelect } from '@/shared/components/input/filterInputs/FilterStatusSelect';
import { FilterTaskTemplateMultiSelect } from '@/shared/components/input/filterInputs/FilterTaskTemplateMultiSelect';
import { FilterDelayedDateRangePicker } from '@/shared/components/input/filterInputs/FilterDelayedDateRangePicker';
import { FilterSubtaskTemplateSelect } from '@/shared/components/input/filterInputs/FilterSubtaskTemplateSelect';
import { FilterRelationSearch } from '@/shared/components/input/filterInputs/FilterRelationSearch';
import { FilterEnumMultiSelect } from '@/shared/components/input/filterInputs/FilterEnumMultiSelect';
import { FilterLegalFormMultiSelect } from '@/shared/components/input/filterInputs/FilterLegalFormMultiSelect';
import { FilterCompanyMultiSelect } from '@/shared/components/input/filterInputs/FilterCompanyMultiSelect';
import { FilterEndFiscalYearMultiSelect } from '@/shared/components/input/filterInputs/FilterEndFiscalYearMultiSelect';
import { FilterPlannedTasksTagsMultiSelect } from '@/shared/components/input/filterInputs/FilterPlannedTasksTagsMultiSelect';
import { FilterResourceTagsMultiSelect } from '@/shared/components/input/filterInputs/FilterResourceTagsMultiSelect';
import { FilterRelationTypeButtons } from '@/shared/components/input/filterInputs/FilterRelationTypeButtons';
import { FilterMyTeamsMultiSelect } from '@/shared/components/input/filterInputs/FilterMyTeamsMultiSelect';
import { FilterTaskPeriodicitySelect } from '@/shared/components/input/filterInputs/FilterTaskPeriodicitySelect';
import { FilterToggleSelect } from '@/shared/components/input/filterInputs/FilterToggleSelect';
import { FilterAssignmentTemplateSelector } from '@/shared/components/input/filterInputs/FilterAssignmentTemplateSelector';
import { FilterRelationGroupMultiSelect } from '@/shared/components/input/filterInputs/FilterRelationGroupMultiSelect';
import { FilterReferenceYear } from '@/shared/components/input/filterInputs/FilterReferenceYear';
import { FilterWrapper } from '@/shared/components/FilterWrapper';
import authService from '@/shared/services/AuthService';
import { TaskBoardFilterKPIs } from './TaskboardFilterKPIs';
import { TaskBoardFilterType, } from '../../constants';
import employeeProfileMessages from '@/shared/messages/employeeProfileMessages';
import { FilterYesNoSelect } from '@/shared/components/input/filterInputs/FilterYesNoSelect';
export var TaskBoardFilters = function (_a) {
    var activeFilters = _a.activeFilters, setFilter = _a.setFilter;
    var formatMessage = useIntl().formatMessage;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var onCreateNewTask = function () {
        setShowModalInfo({
            modalType: ModalType.OneTimeTask,
            relationId: activeFilters.relationId,
        });
    };
    return (_jsxs(SimplePanel, __assign({ article: "5434833712530", title: formatMessage(messages.TaskBoard), buttons: _jsx(CanCreate, __assign({ on: "PlannedTask" }, { children: _jsxs("button", __assign({ onClick: onCreateNewTask, id: "taskboard-new-task-button", title: formatMessage(taskMessages.NewTask), className: "btn btn-inverse", type: "button" }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", __assign({ className: "margin5L" }, { children: formatMessage(messages.Add) }))] })) })) }, { children: [_jsx(TaskBoardFilterKPIs, { filters: activeFilters, setActiveKPI: function (kpi) { return setFilter({ kpi: kpi }); } }), _jsx("div", __assign({ className: "info-block container-fluid" }, { children: _jsx(FilterWrapper, __assign({ filterObject: activeFilters, setFilter: setFilter, resetFilters: undefined, hasActiveFilters: undefined, screen: "TaskBoard", invisibleFilters: ['plannedTaskId', 'invoiceStreamId', 'kpi', 'filterBehaviours'] }, { children: [
                        FilterRelationSearch({
                            item: TaskBoardFilterType.relationId,
                            itemName: TaskBoardFilterType.relationName,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.userId,
                            label: formatMessage(messages.TasksAssignedTo),
                            isAlwaysVisible: true,
                            withUnassigned: true,
                            withNotAssignedToMe: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterTaskTemplateMultiSelect({
                            item: TaskBoardFilterType.taskTemplates,
                            clearItems: [TaskBoardFilterType.subtaskId, TaskBoardFilterType.periodicityId],
                            label: formatMessage(messages.SelectTask),
                            isAlwaysVisible: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterStatusSelect({
                            item: TaskBoardFilterType.status,
                            label: formatMessage(messages.Status),
                            isAlwaysVisible: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterDelayedDateRangePicker({
                            startDateItem: TaskBoardFilterType.deadlineFrom,
                            endDateItem: TaskBoardFilterType.deadlineUntil,
                            startDateId: 'TaskBoardStartDateFilter',
                            endDateId: 'TaskBoardEndDateFilter',
                            startDatePlaceholder: formatMessage(messages.DeadlineFrom),
                            endDatePlaceholder: formatMessage(messages.DeadlineUntil),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterSubtaskTemplateSelect({
                            item: TaskBoardFilterType.subtaskId,
                            label: formatMessage(messages.SelectASubtask),
                            isAlwaysVisible: true,
                            taskTemplatesItem: TaskBoardFilterType.taskTemplates,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterStatusSelect({
                            item: TaskBoardFilterType.subtaskStatus,
                            label: formatMessage(messages.SubtaskStatus),
                            isAlwaysVisible: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterTaskPeriodicitySelect({
                            item: TaskBoardFilterType.periodicityId,
                            label: formatMessage(messages.FilterPeriodicity),
                            isAlwaysVisible: true,
                            taskTemplatesItem: TaskBoardFilterType.taskTemplates,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.vatPeriodicity,
                            type: 'vatPeriodicity',
                            label: formatMessage(messages.VatPeriodicity),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.financialStatementScheme,
                            type: 'financialStatementScheme',
                            label: formatMessage(messages.FinancialStatementScheme),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.socialSecurityFund,
                            type: 'socialSecurityFund',
                            label: formatMessage(messages.SocialSecurityFund),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.socialSecretariat,
                            type: 'socialSecretariat',
                            label: formatMessage(messages.SocialSecretariat),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.accountingSoftware,
                            type: 'accountingSoftware',
                            customItems: [{ id: -1, label: formatMessage(messages.EmptyAccountingSoftware) }],
                            label: formatMessage(messages.AccountingSoftware),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.receiveInvoiceSoftware,
                            type: 'receiveInvoiceSoftware',
                            customItems: [{ id: -1, label: formatMessage(messages.EmptyReceiveInvoiceSoftware) }],
                            label: formatMessage(messages.ReceiveInvoiceSoftware),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.otherSoftware,
                            type: 'otherSoftware',
                            label: formatMessage(messages.OtherSoftware),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.sendInvoiceSoftware,
                            type: 'sendInvoiceSoftware',
                            label: formatMessage(messages.SendInvoiceSoftware),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterCompanyMultiSelect({
                            item: TaskBoardFilterType.ownCompanies,
                            label: formatMessage(messages.OwnCompanies),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEndFiscalYearMultiSelect({
                            item: TaskBoardFilterType.endFiscalYears,
                            label: formatMessage(messages.EndFiscalYear),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.createdBy,
                            label: formatMessage(messages.CreatedBy),
                            withCurrentUser: false,
                            withByPlanning: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.assistant,
                            label: formatMessage(employeeProfileMessages.Assistant),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.assistantBackup,
                            label: formatMessage(employeeProfileMessages.AssistantBackup),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.seniorUser,
                            label: formatMessage(employeeProfileMessages.SeniorUser),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.billingUser,
                            label: formatMessage(employeeProfileMessages.BillingUser),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterAssignmentTemplateSelector({
                            item: TaskBoardFilterType.assignmentTemplateId,
                            label: formatMessage(messages.AssignmentTemplate),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterLegalFormMultiSelect({
                            item: TaskBoardFilterType.legalForms,
                            label: formatMessage(messages.LegalForms),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            showWithoutOption: true,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.relationUserId,
                            label: formatMessage(messages.RelationsAssignedTo),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterResourceTagsMultiSelect({
                            item: TaskBoardFilterType.relationTags,
                            label: formatMessage(messages.WithRelationLabels),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            withFilterBehaviour: true,
                            enabled: true,
                        }),
                        FilterResourceTagsMultiSelect({
                            item: TaskBoardFilterType.withoutRelationTags,
                            label: formatMessage(messages.WithoutRelationLabels),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            withFilterBehaviour: false,
                            enabled: true,
                        }),
                        FilterRelationTypeButtons({
                            item: TaskBoardFilterType.relationTypes,
                            label: formatMessage(messages.RelationType),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterMyTeamsMultiSelect({
                            item: TaskBoardFilterType.teams,
                            label: formatMessage(messages.Teams),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.associate,
                            label: formatMessage(employeeProfileMessages.Associate),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.responsible,
                            label: formatMessage(employeeProfileMessages.Responsible),
                            withUnassigned: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterPlannedTasksTagsMultiSelect({
                            item: TaskBoardFilterType.withoutTags,
                            label: formatMessage(messages.WithoutTaskLabels),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            withFilterBehaviour: false,
                            enabled: true,
                        }),
                        FilterPlannedTasksTagsMultiSelect({
                            item: TaskBoardFilterType.withTags,
                            label: formatMessage(messages.WithTaskLabels),
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            withFilterBehaviour: true,
                            enabled: true,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.onlySubtasksForAssignedUser,
                            label: formatMessage(messages['Show only subtask assigned to selected user']),
                            isAlwaysVisible: true,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.userIsNextAssignedUser,
                            label: formatMessage(messages['Show tasks where the selected user is next in line']),
                            tooltip: formatMessage(messages.ShowTasksWhereSelectedUserIsNextInLineTooltip),
                            isAlwaysVisible: true,
                            enabled: true,
                            setFilter: function (updatedFilters) {
                                // when enabling this filter and no userId is filtered, set the userId to the current user
                                if (updatedFilters.userIsNextAssignedUser && !activeFilters.userId) {
                                    setFilter(__assign(__assign({}, updatedFilters), { userId: authService.getUserId() }));
                                }
                                else {
                                    setFilter(updatedFilters);
                                }
                            },
                            activeFilters: activeFilters,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.includeDoneTasksInThePast,
                            label: formatMessage(messages.IncludeDoneTasksInThePast),
                            isAlwaysVisible: false,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterRelationGroupMultiSelect({
                            item: TaskBoardFilterType.relationGroups,
                            label: formatMessage(messages.RelationGroups),
                            isAlwaysVisible: false,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterReferenceYear({
                            item: TaskBoardFilterType.year,
                            label: formatMessage(messages.ReferenceYear),
                            isAlwaysVisible: false,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: authService.hasFeature('referenceYear'),
                        }),
                        FilterYesNoSelect({
                            item: TaskBoardFilterType.mixedTaxPayer,
                            label: formatMessage(messages.MixedTaxPayer),
                            isAlwaysVisible: false,
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.mixedTaxPayerVatDeductionMethod,
                            type: 'MixedTaxPayerVatDeductionMethod',
                            label: formatMessage(messages.MixedTaxPayerVatDeductionMethod),
                            customItems: [
                                { id: -1, label: formatMessage(messages.EmptyMixedTaxPayerVatDeductionMethod) },
                            ],
                            setFilter: setFilter,
                            activeFilters: activeFilters,
                            enabled: true,
                        }),
                    ] })) }))] })));
};
